import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ItemDocumentFinder = React.lazy(() => import('.'));

export const itemDocumentFinderRoutes = [
  new Route({
    path: 'item-document-finder',
    element: ItemDocumentFinder,
    children: [],
  }),
];
